import { t, type I18nLocale } from '@ardoq/i18n';
import type { TableEmptyStateLabels } from '@ardoq/table';

type GetGremlinEmptyStateLabelsArgs = {
  i18nLocale: I18nLocale;
  isFilteredBySearch: boolean;
};

export const getGremlinEmptyStateLabels = ({
  i18nLocale,
  isFilteredBySearch,
}: GetGremlinEmptyStateLabelsArgs): TableEmptyStateLabels => {
  if (isFilteredBySearch) {
    return {
      noResultsTitle: t(
        i18nLocale,
        'search:gremlinResults.emptyState.noSearchMatchesTitle',
        'No results match your search'
      ),
      noResultsDescription: t(
        i18nLocale,
        'search:gremlinResults.emptyState.noSearchMatchesDescription',
        'Clear or change the search text to see all results from your query.'
      ),
    };
  }
  return {
    noResultsTitle: t(
      i18nLocale,
      'search:gremlinResults.emptyState.noResultsTitle',
      'Your query returned no results'
    ),
    noResultsDescription: t(
      i18nLocale,
      'search:gremlinResults.emptyState.noResultsDescription',
      'Change your query and try again.'
    ),
  };
};
